import { configureStore } from "@reduxjs/toolkit";
import artifactColumnSlice from "./artifactColumn/artifactColumnSlice";
import artifactUploaderSlice from "./artifactUploader/artifactUploaderSlice";
import datasetSlice from "./edcDataset/datasetSlice";
import searchFilterSlice from "./searchFilter/searchFilterSlice";
import userSlice from "./userSlice/userSlice";
import navigationBlockSlice from "./navigationBlock/navigationBlockSlice";

// Configurar el store en REDUX TOOKIT (RTK)
const store = configureStore({
	reducer: {
		user: userSlice.reducer,
		searchFilter: searchFilterSlice.reducer,
		uploadFile: artifactUploaderSlice.reducer,
		artifactColumn: artifactColumnSlice.reducer,
		dataset: datasetSlice.reducer,
		navigationBlock: navigationBlockSlice.reducer,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
